import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOpen: false,
    pestId: null,
    componentData: null
};

const pestThresholdModal = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        closePestThresholdModal(state) {
            state.isOpen = false;
            state.componentId = null;
            state.componentData = null;
        },
        openPestThresholdModal(state, action) {
            state.isOpen = action.payload.isOpen;
            state.pestId = action.payload.pestId;
        },
        storedPestThresholdModalData(state, action) {
            state.componentData = action.payload.componentData;
            state.isOpen = action.payload.isOpen
        },

    }
});

export const { openPestThresholdModal, closePestThresholdModal,storedPestThresholdModalData } = pestThresholdModal.actions;

export default pestThresholdModal.reducer;